import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCheckCircled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9999 0.935486C4.09837 0.935486 0.935547 4.09831 0.935547 7.99984C0.935547 11.9013 4.09837 15.0642 7.9999 15.0642C11.9014 15.0642 15.0642 11.9013 15.0642 7.99984C15.0642 4.09831 11.9014 0.935486 7.9999 0.935486ZM1.94889 7.99984C1.94889 4.65795 4.65802 1.94881 7.9999 1.94881C11.3418 1.94881 14.0509 4.65795 14.0509 7.99984C14.0509 11.3417 11.3418 14.0509 7.9999 14.0509C4.65802 14.0509 1.94889 11.3417 1.94889 7.99984ZM10.8362 5.90689C11.0057 5.66601 10.9478 5.33332 10.707 5.1638C10.4661 4.99429 10.1334 5.05215 9.96386 5.29304L6.95442 9.56961L5.71393 8.30617C5.50756 8.09599 5.16989 8.09289 4.95971 8.29926C4.74953 8.50561 4.74643 8.84329 4.9528 9.05346L6.64169 10.7736C6.75258 10.8866 6.90791 10.9444 7.06567 10.9315C7.22343 10.9187 7.36732 10.8363 7.45841 10.7069L10.8362 5.90689Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCheckCircled)
const IconSvgCheckCircled = createIcon(ForwardRef, 'SvgCheckCircled')
export default IconSvgCheckCircled
